import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../_helpers";
const Availability = (data) => {
    return (
        <>
            {data.availability === "Guaranteed" ? (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip">Guaranteed</Tooltip>}
                >
                    <img
                        className=" availIco mr-1"
                        alt={data.availability}
                        src={toAbsoluteUrl(
                            `/media/svg/availibility/availability_guaranteed.svg`
                        )}
                    />
                </OverlayTrigger>
            ) : data.availability === "Memo" ? (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip">Memo</Tooltip>}
                >
                    <img
                        className=" availIco mr-1"
                        alt={data.availability}
                        src={toAbsoluteUrl(
                            `/media/svg/availibility/availability_primary.svg`
                        )}
                    />
                </OverlayTrigger>
            ) : data.availability === "Hold" ? (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip">Hold</Tooltip>}
                >
                    <img
                        className=" availIco mr-1"
                        alt={data.availability}
                        src={toAbsoluteUrl(
                            `/media/svg/availibility/availability_primary.svg`
                        )}
                    />
                </OverlayTrigger>
            ) : data.availability === "Not Available" ? (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip">Not Available</Tooltip>}
                >
                    <img
                        className=" availIco mr-1"
                        alt={data.availability}
                        src={toAbsoluteUrl(
                            `/media/svg/availibility/availability_danger.svg`
                        )}
                    />
                </OverlayTrigger>
            ) : data.availability === "Subject to Prior sale" ? (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip">Subject to Prior sale</Tooltip>
                    }
                >
                    <img
                        className=" availIco mr-1"
                        alt={data.availability}
                        src={toAbsoluteUrl(
                            `/media/svg/availibility/availability_warning.svg`
                        )}
                    />
                </OverlayTrigger>
            ) : (
                <img
                    className=" availIco mr-1"
                    alt={data.availability}
                    src={toAbsoluteUrl(
                        `/media/svg/availibility/availability_blank_gray.svg`
                    )}
                />
            )}
        </>
    );
};
export default Availability;
